export enum ConsultationType {
    None = 0,
    ShowPhoneButton = 1,
    OnlineConsultation = 3,
    NoAskForReplacementItems = 5,
}
